/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppLocalization } from '../../models/app-localization';
import { CreateAppLocalizationDto } from '../../models/create-app-localization-dto';

export interface AppLocalizationsControllerCreate$Params {
  
    /**
     * The user data to create a new localization
     */
    body: CreateAppLocalizationDto
}

export function appLocalizationsControllerCreate(http: HttpClient, rootUrl: string, params: AppLocalizationsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AppLocalization>> {
  const rb = new RequestBuilder(rootUrl, appLocalizationsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppLocalization>;
    })
  );
}

appLocalizationsControllerCreate.PATH = '/localizations';
